/* eslint-disable no-else-return */

import MenuItem from '@material-ui/core/MenuItem'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import ActionButton from '../Button/ActionButton'

export const PrimaryAction = ({ action, white, index }) => {
  if (action.type === 'internal') {
    return (
      <ActionButton
        className="rowActionItem"
        component={Link}
        disabled={action.isDisabled}
        key={index}
        to={action.action}
        white={white}
      >
        {action.name}
      </ActionButton>
    )
  } else if (action.type === 'external') {
    return (
      <ActionButton
        className="rowActionItem"
        disabled={action.isDisabled}
        key={index}
        href={action.action}
        target="_blank"
        rel="noopener noreferrer"
        download={action.download}
        white={white}
      >
        {action.name}
      </ActionButton>
    )
  } else {
    return (
      <ActionButton
        className="rowActionItem"
        disabled={action.isDisabled}
        key={index}
        onClick={action.action}
        white={white}
      >
        {action.name}
      </ActionButton>
    )
  }
}

const StyledMenuItem = styled(MenuItem)`
  &.disabledMenu {
    opacity: 0.7 !important;
  }
`

export const SecondaryAction = ({ action, index }) => {
  if (action.type === 'internal') {
    return (
      <StyledMenuItem
        className={action.isDisabled ? 'disabledMenu' : 'menu'}
        component={Link}
        disabled={action.isDisabled}
        key={index}
        tabIndex={0}
        to={action.action}
        onClick={event => event.stopPropagation()}
        onFocus={event => event.stopPropagation()}
      >
        {action.name}
      </StyledMenuItem>
    )
  } else if (action.type === 'external') {
    return (
      <StyledMenuItem
        className={action.isDisabled ? 'disabledMenu' : 'menu'}
        disabled={action.isDisabled}
        key={index}
        tabIndex={0}
        target="_blank"
        component="a"
        rel="noopener noreferrer"
        href={action.action}
        onClick={event => event.stopPropagation()}
        onFocus={event => event.stopPropagation()}
        download={action.download}
      >
        {action.name}
      </StyledMenuItem>
    )
  } else {
    return (
      <StyledMenuItem
        className={action.isDisabled ? 'disabledMenu' : 'menu'}
        disabled={action.isDisabled}
        key={index}
        tabIndex={0}
        type="button"
        onClick={action.action}
        onFocus={event => event.stopPropagation()}
      >
        {action.name}
      </StyledMenuItem>
    )
  }
}
